export const NextActionsRequiredRoutes = [
  {
    path: 'nextActionRequired',
    lazy: () => import('./NextActionsRequiredPage'),
  },
] as const
